/**
 * R268w · Feb 2026 — Currency helpers for multi-currency billing.
 *
 * Central place so every screen (composer, preview, payment dialog,
 * detail row, billing setup) formats money the same way — regardless
 * of the currency the doc was raised in.
 */

// Ordered so the picker shows the most common currencies first for
// Indian workspaces billing overseas customers.
export const CURRENCIES = [
  { code: "INR", symbol: "₹",    label: "Indian Rupee",    locale: "en-IN" },
  { code: "USD", symbol: "$",    label: "US Dollar",       locale: "en-US" },
  { code: "EUR", symbol: "€",    label: "Euro",            locale: "en-DE" },
  { code: "GBP", symbol: "£",    label: "Pound Sterling",  locale: "en-GB" },
  { code: "AED", symbol: "AED",  label: "UAE Dirham",      locale: "en-AE" },
  { code: "SGD", symbol: "S$",   label: "Singapore Dollar",locale: "en-SG" },
  { code: "AUD", symbol: "A$",   label: "Australian Dollar",locale: "en-AU" },
  { code: "CAD", symbol: "C$",   label: "Canadian Dollar", locale: "en-CA" },
  { code: "JPY", symbol: "¥",    label: "Japanese Yen",    locale: "ja-JP" },
];

export const CURRENCY_BY_CODE = Object.fromEntries(
  CURRENCIES.map((c) => [c.code, c]),
);

/**
 * Format a numeric amount in the given currency using an Intl-friendly
 * locale. Falls back to a bare symbol prefix if the runtime rejects
 * the currency code (never throws).
 */
export function fmtMoney(amount, currency = "INR") {
  const n = Number(amount || 0);
  const c = CURRENCY_BY_CODE[currency] || CURRENCY_BY_CODE.INR;
  try {
    return new Intl.NumberFormat(c.locale, {
      style: "currency",
      currency: c.code,
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    }).format(n);
  } catch (e) {
    return `${c.symbol}${n.toLocaleString("en-IN", { maximumFractionDigits: 2, minimumFractionDigits: 2 })}`;
  }
}

export function currencySymbol(code) {
  return (CURRENCY_BY_CODE[code] || CURRENCY_BY_CODE.INR).symbol;
}
